const session = {
    not_found: '未找到會話。請返回並重新登錄。',
    invalid_credentials: '帳號或密碼錯誤，請重新輸入。',
    invalid_sign_in_method: '當前登錄方式不可用',
    invalid_connector_id: '找不到識別碼為 {{connectorId}} 的可用連接器。',
    insufficient_info: '登錄信息缺失，請檢查你的輸入。',
    connector_id_mismatch: '傳入的連接器識別碼與工作階段中儲存的記錄不一致',
    connector_session_not_found: '無法找到連接器登錄信息，請嘗試重新登錄。',
    verification_session_not_found: '驗證失敗，請重新驗證。',
    verification_expired: '當前頁面已超時。為確保你的帳號安全，請重新驗證。',
    verification_blocked_too_many_attempts: '在短時間內嘗試次數過多。請於 {{relativeTime}} 後再試。',
    unauthorized: '請先登錄',
    unsupported_prompt_name: '不支援的提示參數名稱（prompt name）',
    forgot_password_not_enabled: '忘記密碼功能沒有開啟。',
    verification_failed: '驗證失敗，請重新驗證。',
    connector_validation_session_not_found: '找不到用於驗證權杖的連接器資訊。',
    csrf_token_mismatch: '跨網站請求偽造（CSRF）權杖不匹配。',
    identifier_not_found: '找不到使用者識別碼。請返回並重新登錄。',
    interaction_not_found: '找不到交互會話。請返回並重新開始會話。',
    invalid_interaction_type: '此操作不支援當前的交互。請啟動一個新的會話。',
    not_supported_for_forgot_password: '該操作不支援忘記密碼。',
    identity_conflict: '檢測到身分不匹配。請啟動一個新的會話以進行不同的身分驗證。',
    identifier_not_verified: '提供的識別碼 {{identifier}} 尚未驗證。請為此識別碼創建一個驗證記錄並完成驗證過程。',
    mfa: {
        require_mfa_verification: '需要多因素驗證驗證才能登錄。',
        mfa_sign_in_only: '多因素驗證只能用於登錄交互。',
        pending_info_not_found: '未找到尚未處理的多因素驗證資訊，請先初始化多因素驗證。',
        invalid_totp_code: '無效的時間型一次性密碼（TOTP）驗證碼。',
        webauthn_verification_failed: '網路身分驗證（WebAuthn）驗證失敗。',
        webauthn_verification_not_found: '找不到網路身分驗證（WebAuthn）驗證。',
        bind_mfa_existed: '多因素驗證已存在。',
        backup_code_can_not_be_alone: '備份碼不能作為唯一的多因素驗證。',
        backup_code_required: '需要備份碼。',
        invalid_backup_code: '無效的備份碼。',
        mfa_policy_not_user_controlled: '多因素驗證策略不受用戶控制。',
        mfa_factor_not_enabled: '多因素驗證因素未啟用。',
        suggest_additional_mfa: '為了更強的保護，建議新增另一種多重驗證方式。你可以跳過此步驟並繼續。',
    },
    passkey_sign_in: {
        pending_info_not_found: '未找到待處理的通行金鑰登入資訊。請重新啟動登入流程。',
        conflict_rp_id: '信賴方識別碼不相符。請使用正確的用戶端登入。',
        sso_users_not_allowed: '單一登入使用者無法使用通行金鑰登入選項。',
    },
    password_expiration: {
        reset_not_allowed: '只有在目前登入階段的密碼已過期後，才允許重設密碼。',
    },
    sso_enabled: '該郵箱已開啟單點登錄，請使用單一登入登錄。',
    captcha_required: '需要驗證碼。',
    captcha_failed: '驗證碼驗證失敗。',
    email_blocklist: {
        disposable_email_validation_failed: '電子郵件地址驗證失敗。',
        invalid_email: '無效的電子郵件地址。',
        email_subaddressing_not_allowed: '不允許使用電子郵件子地址。',
        email_not_allowed: '電子郵件地址 "{{email}}" 受到限制。請選擇不同的地址。',
    },
    google_one_tap: {
        cookie_mismatch: 'Google One Tap瀏覽器儲存資料不匹配。',
        invalid_id_token: '無效的Google身分權杖。',
        unverified_email: '未驗證的電子郵件。',
    },
};
export default Object.freeze(session);
